// extracted by mini-css-extract-plugin
export var formContainer = "_mi-0";
export var message = "_mi-1";